import CCColors from '@/Utils/CCColors';
import {FontSizes} from '@/Utils/Dimensions';
import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {},
  active: {
    borderBottomWidth: 2,
    paddingBottom: 16,
    borderBottomColor: CCColors.Buttons.Background,
  },
  outerContainer: {
    flex: 1,
    height: '100vh',
    padding: 32,
    justifyContent: 'flex-start',
  },
  mainHeading: {
    fontSize: FontSizes[24],
    fontWeight: '500',
    color: CCColors?.TextColor?.Dark,
    marginBottom: 32,
  },
  addButton: {
    justifyContent: 'center',
    marginTop: 24,
  },
});
